import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GlobalProvider } from "./global";
import { BaseHelper } from "src/app/baseHelper";

@Injectable({
  providedIn: "root",
})
export class APIBaseService {
  constructor(
    public http: HttpClient,
    public g: GlobalProvider,
    private b: BaseHelper
  ) {}

  getHeader(params = {}) {
    return {
      headers: new HttpHeaders({
        Authorization: "Bearer "+this.g.jws,
      }),
      params,
    };
  }
  errorHandle(err) {
    this.b.loadLoading(false);
    let message = err.error ? err.error.message : err.message;
    if (!message) message = err.error ? err.error : "unknown error";

    this.b.toast(`${err.status}: ${message}`, 5000, `danger`);
  }

  customError(err) {
    this.b.loadLoading(false);
    this.b.toast(`${err}`, 5000, `danger`);
  }

  infoError(err) {
    this.b.loadLoading(false);
    this.b.toast(`${err}`, 7000, `tertiary`);
  }
}
